import { RowSkeleton } from './RowSkeleton';
import { TableWrapper } from './TableWrapper';

export const HighestCampaignsTableSkeleton = () => (
  <TableWrapper data-test="audience-counts-table-skeleton">
    {new Array(5).fill(<RowSkeleton />)}
  </TableWrapper>
);
